// Expando component

/* global require */

import Vue from "vue";
import { trans } from "common/translate.js";

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export default Vue.component("expando", {
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    }
  },
  computed: {
    buttonLabel() {
      return `${capitalize(this.expanded ? trans("show less") : trans("show more")) }…`;
    }
  },

  template: "<div> <slot :toggle='toggle' :buttonLabel='buttonLabel' :expanded='expanded'></slot> </div>",
});





// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/image/expando.js